








import { Component, Prop, Vue } from "vue-property-decorator";
import ContactForm from "../contact/ContactForm.vue";

@Component({
  components: {
    ContactForm,
  },
})
export default class EmailForm extends Vue {
  @Prop() labelCondition!: boolean;
  @Prop() diasbleCancelButton!: boolean;
}
